import(/* webpackMode: "eager" */ "/tmp/8de3bd17dbe0d82/app/[locale]/error.tsx");
